export enum FeatureFlags {
  SAMPLE_FEATURE = 'SAMPLE_FEATURE',
  FILTER_PEOPLE_SKILLS = 'FILTER_PEOPLE_SKILLS',
  CRAWL_REQUEST = 'CRAWL_REQUEST',
  PEOPLE_LOOKALIKE_SEARCH = 'PEOPLE_LOOKALIKE_SEARCH',
  INTEGRATION_SMARTLEAD = 'INTEGRATION_SMARTLEAD',
  FILTER_COMPANY_BULK_SEARCH = 'FILTER_COMPANY_BULK_SEARCH',
  FILTER_COMPANY_PEOPLE_TECHNOLOGIES = 'FILTER_COMPANY_PEOPLE_TECHNOLOGIES',
  PEOPLE_EXPORT_TEMPLATE = 'PEOPLE_EXPORT_TEMPLATE',
  PROFILE_INSIGHT_EXPORT_DIALOG = 'PROFILE_INSIGHT_EXPORT_DIALOG',
  COMPANY_EXPORT_TEMPLATE = 'COMPANY_EXPORT_TEMPLATE',
  BILLING_PAGE = 'BILLING_PAGE',
  PEOPLE_ENRICHMENT = 'PEOPLE_ENRICHMENT',
  EMAIL_ENRICHMENT = 'EMAIL_ENRICHMENT',
  ENRICHMENT = 'ENRICHMENT',
  RESEND_INVITE_EMAIL = 'RESEND_INVITE_EMAIL',
  BUYING_TEAM = 'BUYING_TEAM',
  ALERTS = 'ALERTS',
  COMPANY_SEMANTIC_SEARCH = 'COMPANY_SEMANTIC_SEARCH',
  FILTER_PEOPLE_BULK_SEARCH = 'FILTER_PEOPLE_BULK_SEARCH',
  BACK_OFFICE = 'BACK_OFFICE',
  PEOPLE_PHONE_NUMBER = 'PEOPLE_PHONE_NUMBER',
  SEARCH_TABLE_COLUMN_MODIFIER = 'SEARCH_TABLE_COLUMN_MODIFIER',
  SEARCH_PAYLOAD_DIALOG = 'SEARCH_PAYLOAD_DIALOG',
  FILTER_PEOPLE_JOB_TITLE_AI_SEARCH = 'FILTER_PEOPLE_JOB_TITLE_AI_SEARCH',
  TOP_LOOKALIKE_PEOPLE_ON_PEOPLE_PAGE = 'TOP_LOOKALIKE_PEOPLE_ON_PEOPLE_PAGE',
  EXPORT_COMPANY_FOLLOWER_COUNT = 'EXPORT_COMPANY_FOLLOWER_COUNT',
  EXPORT_COMPANY_NAIC_CODE = 'EXPORT_COMPANY_NAIC_CODE',
  EXPORT_COMPANY_SIC_CODE = 'EXPORT_COMPANY_SIC_CODE',
  EXPORT_PEOPLE_AI_SEARCH_INPUT = 'EXPORT_PEOPLE_AI_SEARCH_INPUT',
  EXPORT_PEOPLE_RELEVANCY_SCORE = 'EXPORT_PEOPLE_RELEVANCY_SCORE',
  EXPORT_PEOPLE_WORK_DIRECT_PHONE = 'EXPORT_PEOPLE_WORK_DIRECT_PHONE',
  EXPORT_PEOPLE_HOME_PHONE = 'EXPORT_PEOPLE_HOME_PHONE',
}
